var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5209 15.7084V9.66671C17.5209 7.99835 16.1684 6.64587 14.5 6.64587C12.8317 6.64587 11.4792 7.99835 11.4792 9.66671V14.5C11.4792 14.9297 11.4792 15.1042 11.4792 15.7084H9.66669C9.66669 15.1042 9.66669 14.9173 9.66669 14.5V9.66671C9.66669 6.99733 11.8306 4.83337 14.5 4.83337C17.1693 4.83337 19.3334 6.99733 19.3334 9.66671V15.7084H18.125H17.5209Z",
    fill: "#0047AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66669 12.0834C7.66466 12.0834 6.04169 13.7063 6.04169 15.7084V21.75C6.04169 23.7521 7.66466 25.375 9.66669 25.375H19.3334C21.3354 25.375 22.9584 23.7521 22.9584 21.75V15.7084C22.9584 13.7063 21.3354 12.0834 19.3334 12.0834H9.66669ZM14.5 16.9167C13.8327 16.9167 13.2917 17.4577 13.2917 18.125V19.3334C13.2917 20.0007 13.8327 20.5417 14.5 20.5417C15.1674 20.5417 15.7084 20.0007 15.7084 19.3334V18.125C15.7084 17.4577 15.1674 16.9167 14.5 16.9167Z",
    fill: "#6495ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cab87b0d9eb826278e25a5f65bc25324.svg";
export { ForwardRef as ReactComponent };